import { GET_PAYROLL_LOANED_EMPLOYEES } from '@/constants/ActionTypes';

export const getPayrollLoanedEmployees = data => ({
  type: GET_PAYROLL_LOANED_EMPLOYEES,
  payload: data,
});
